import { Dialog, DialogContent, Box, IconButton, useTheme, useMediaQuery } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import AgentCreateTicket from '../../pages/agent/CreateTicket'
import CustomerCreateTicket from '../../pages/customer/CreateTicket'

interface CreateTicketModalProps {
  open: boolean
  onClose: () => void
  onSuccess: (ticketId: string) => void
  userType: 'agent' | 'customer'
}

export function CreateTicketModal({ open, onClose, onSuccess, userType }: CreateTicketModalProps) {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const handleSuccess = (ticketId: string) => {
    onSuccess(ticketId)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      fullScreen={fullScreen}
    >
      <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        <Box sx={{ p: 3 }}>
          {userType === 'agent' ? (
            <AgentCreateTicket isModal={true} onSuccess={handleSuccess} onCancel={onClose} />
          ) : (
            <CustomerCreateTicket isModal={true} onSuccess={handleSuccess} onCancel={onClose} />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
